<a
  class="card"
  [class.card--pending]="!configured()"
  [attr.href]="configured() ? portal().url : null"
  [attr.target]="configured() ? '_blank' : null"
  [attr.rel]="configured() ? 'noopener noreferrer' : null"
  [attr.aria-label]="
    configured()
      ? 'Abrir el portal ' + portal().name + ' en una pestaña nueva'
      : 'Portal ' + portal().name + ': URL pendiente de configurar'
  "
>
  <span class="card__glow" aria-hidden="true"></span>
  <span class="card__rule" aria-hidden="true"></span>

  <canvas #canvas class="card__canvas" aria-hidden="true"></canvas>

  <span class="card__body">
    <span class="card__eyebrow">Portal</span>
    <span class="card__title">{{ portal().name }}</span>
    <span class="card__tagline">{{ portal().tagline }}</span>

    <span class="card__cta">
      @if (configured()) {
        <span>Abrir portal</span>
        <svg class="card__arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M14 4h6v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M20 4 10 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M19 14.5V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4.5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      } @else {
        <span>URL pendiente de configurar</span>
      }
    </span>
  </span>
</a>
